import * as React from "react";

const NotFound = (): JSX.Element => (
  <div className="not-found">404! Nội dung không tồn tại</div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.tsx